import { Component, OnInit,ViewChild } from "@angular/core";
import { FormBuilder} from "@angular/forms";
import { Router,ActivatedRoute } from "@angular/router";
import { RestringirMccProdutoClienteCartaoService } from "./restringir-mcc-produto-cliente-cartao.service";
import { NotificationsService } from "angular2-notifications";
import { Location } from "@angular/common";
import { NgxSpinnerService } from "ngx-spinner";
import { NbDialogService } from "@nebular/theme";
import { HttpParams } from "@angular/common/http";
import {DatatableComponent} from '@swimlane/ngx-datatable';
import {SpringDatatablePaginationService} from '../../../shared/services/spring-integration/pagination/spring-datatable-pagination.service';
import {SpringDatatablePagination} from '../../../shared/services/spring-integration/pagination/spring-datatable-pagination';
import { EncriptyUtilService } from '../../../shared/services/encripty-util.service';

@Component({
  selector: "ngx-restringir-mcc-produto-cliente-cartao",
  templateUrl: "./restringir-mcc-produto-cliente-cartao.component.html",
  styleUrls: ["./restringir-mcc-produto-cliente-cartao.component.scss"],
})
export class RestringirMccProdutoClienteCartaoComponent implements OnInit {

  @ViewChild('formCartaoMcc', null)
  public table: DatatableComponent;

  public spinnerLoad: boolean = false;
  public formCartaoMcc = null;
  public rowData = null;
  public tamanhoLista = null;

  datatablePagination: SpringDatatablePagination = new SpringDatatablePagination();
  activatedRoute: ActivatedRoute;

  constructor(
    private notifications: NotificationsService,
    private formBuilder: FormBuilder,
    private service: RestringirMccProdutoClienteCartaoService,
    private location: Location,
    private spinnerService: NgxSpinnerService,
    private dialogService: NbDialogService,
    private router: Router,
    private paginationService: SpringDatatablePaginationService,
    private encriptyService: EncriptyUtilService
  ) {
    this.paginationService.setDatatablePagination(this.datatablePagination);
    this.formCartaoMcc = this.formBuilder.group({
      nomeCartao: [null],
      ultimos4Digitos: [null],
      restricaoHabilitada : ["todos"]
    });
  }

  ngOnInit() {
    this.buscar(0)
  }

  previousPage() {
    this.router.navigate(['/iot-dashboard']);
  }

  buscar(page?:any) {

    let pageNumber;
    let params = new HttpParams();

    if (page != null) {
      pageNumber = page;
      params = params.append('page', String(pageNumber));
    }

    let nomeCartao = this.formCartaoMcc.controls["nomeCartao"].value;
    if (nomeCartao != null) {
      params = params.append('nomeCartao', nomeCartao );
    }

    let ultimos4Digitos = this.formCartaoMcc.controls["ultimos4Digitos"].value;
    if (ultimos4Digitos != null) {
      params = params.append('ultimos4Digitos', ultimos4Digitos );
    }

    let restricaoHabilitada = this.formCartaoMcc.controls["restricaoHabilitada"].value;
    if (restricaoHabilitada != 'todos') {
      params = params.append('restricaoHabilitada', restricaoHabilitada );
    }

this.spinnerService.show();
this.service.buscaCartoes(
  params,
    (response) => {
      this.rowData = response.cards;
      this.tamanhoLista = response.cards.length;
      this.rowData = this.rowData.map(data => {
        return {
          restricao: data.restricaoMcc == 'S' ? "SIM": "NÃO",
          ultimos4Digitos: data.ultimosQuatroDigitos,
          nomeCartao: data.nomeTitular,
          cartaoPrePagoId: data.cartaoPrePagoId
        };
      });
      response.content = this.rowData;
      response.number = page;
      response.totalPages = Math.trunc(response.qtd / 20) + 1 ;
      response.totalElements = response.qtd;
      response.size = 20;
      this.paginationService.setInfo(response);

      if (this.tamanhoLista == 0) {
        this.notifications.warn('Não há dados para o período informado!');
      }
      this.spinnerService.hide();

    },(error) => {
      this.spinnerService.hide();
      this.notifications.error(error.message);
    })

  }


  gotoEditar(row:any){
    let id = this.encriptyService.encriptyBySecretKey('' + row.cartaoPrePagoId)

    let params = {

      'id': id,

    }

    this.router.navigate(['/pages/backoffice/restringir-mcc-produto-cliente-cartao-edit'], { relativeTo: this.activatedRoute, queryParams: params });
  }
}
